import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTasks = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.175 13.35 5.55 19 2 15.45l1.4-1.4 2.125 2.125 4.25-4.25zM22 17h-9v-2h9zM11.175 5.35 5.55 11 2 7.45l1.4-1.4 2.125 2.125 4.25-4.25zM22 9h-9V7h9z" })
});
export default SvgTasks;
